<template>
  <div />
</template>

<script>
import { mapActions } from 'vuex';

export default {
  mounted() {
    this.$log.info('logging out');
    this.LOGOUT_auth();
    this.$router.push('/');
  },
  methods: {
    ...mapActions('auth', ['LOGOUT_auth']),
  },
};
</script>
